import dayjs from "dayjs";
import { ColumnItem } from "../../../../../common/models/table";
import {
  useWaitingTimeListState,
  useWaitingTimeStore,
} from "../../../store/ShiftingStore";
import { useEffect, useState } from "react";
import { ActionsKey } from "../../../../../common/models/Actions";
import { WaitingTimeService } from "../../../core/_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../../common/components/Loader/Loader";
import { LFTableV3 } from "../../../../../common/components/LFTable/LFTableV3";
import { CustomDrawer } from "../../../../../common/components/Drawer/CustomDrawer";
import { WaitingTimeForm } from "./components/WaitingTimeForm";
import { useLocation } from "react-router";

const cols: ColumnItem[] = [
  {
    key: "reason",
    title: "Motif",
    dataIndex: "reason",
    show: true,
  },
  {
    key: "startAt",
    title: "Heure de début",
    dataIndex: "startAt",
    /* render: (value: any) =>
      value ? dayjs(value, "DD/MM/YYYY HH:mm:ss").format("HH:mm") : "-", */
    isCanSort: false,
    show: true,
  },
  {
    key: "endAt",
    title: "Heure de fin",
    dataIndex: "endAt",
    /* render: (value: any) =>
      value ? dayjs(value, "DD/MM/YYYY HH:mm:ss").format("HH:mm") : "-", */
    isCanSort: false,
    show: true,
  },
  {
    key: "duration",
    title: "Durée (heures)",
    dataIndex: "duration",
    show: true,
  },
];

export const WaitingTimeList = () => {
  const { setShiftingList, shiftingList, actioned, totalItems, setActioned } =
    useWaitingTimeStore();
  const { pageState, setPageState, resetPageState } = useWaitingTimeListState();

  const [isShowForm, setIsShowForm] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const movementId = queryParams.get("movment");

  useEffect(() => {
    fetchAllShiftingOperations({ "movement.id": movementId, ...pageState });
  }, [pageState, movementId]);

  useEffect(() => {
    if (!isShowForm) {
      setActioned({ action: "no", data: null });
    }
  }, [isShowForm]);

  const onActionClick = (item: any, action: ActionsKey) => {
    const id = parseInt(item?.["@id"]?.split("/").pop() || "", 10);

    if (action === "delete") {
      onDeleteHandler(id);
    } else {
      getOne(id, action);
    }
  };

  const onShowAddHandler = () => {
    setIsShowForm((prev: boolean) => !prev);
  };

  const getOne = async (id: number, action: any) => {
    try {
      setIsLoading(true);
      const res = await WaitingTimeService.getWaitingTimeById(id);
      if (res?.status === HttpStatusCode.Ok) {
        setActioned({
          data: {
            ...res?.data,
          },
          action,
        });
      }
      onShowAddHandler();
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onDeleteHandler = async (id: number) => {
    try {
      setIsLoading(true);
      const res = await WaitingTimeService.deleteWaitingTime(id);
      if (res?.status === HttpStatusCode.NoContent) {
        fetchAllShiftingOperations({ "movement.id": movementId, ...pageState });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllShiftingOperations = async (params?: any) => {
    try {
      setIsLoading(true);
      const res = await WaitingTimeService.getWaitingTimeList(params);
      if (res?.status === HttpStatusCode.Ok) {
        setShiftingList(res.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onFinishAction = () => {
    //resetPageState();
    onShowAddHandler();
    setPageState({ ...pageState });
  };

  const handleSetParams = (params: any) => {
    setPageState({
      ...params,
    });
  };

  return (
    <>
      <Loader isLoading={isLoading} />

      <LFTableV3
        columns={cols}
        params={pageState}
        data={shiftingList}
        onAction={onActionClick}
        isCanDelete={() => true}
        isCanEdit={() => true}
        onSearch={handleSetParams}
        onSort={handleSetParams}
        onResetSearch={resetPageState}
        onChangePage={handleSetParams}
        pagination={{
          defaultCurrentPage: pageState.page,
          itemsPerPage: pageState?.itemsPerPage,
          totalItems: totalItems,
        }}
      />

      {/* Drawer section  */}
      {isShowForm ? (
        <CustomDrawer
          isOpen={isShowForm}
          onClose={onShowAddHandler}
          title={"Modification"}
          width={"75%"}
        >
          <WaitingTimeForm
            onFinish={onFinishAction}
            {...(actioned?.action === "update"
              ? {
                  initialValue: actioned?.data,
                }
              : {})}
          />
        </CustomDrawer>
      ) : (
        ""
      )}
    </>
  );
};
